const STORE_KEY = 'AUTH'

export const START_AUTH_LOADING = `${STORE_KEY}/START_AUTH_LOADING`
export const FINISH_AUTH_LOADING = `${STORE_KEY}/FINISH_AUTH_LOADING`

export const FETCH_AUTH_STATUS_REQUEST = `${STORE_KEY}/FETCH_AUTH_STATUS_REQUEST`
export const FETCH_AUTH_STATUS_SUCCESS = `${STORE_KEY}/FETCH_AUTH_STATUS_SUCCESS`
export const FETCH_AUTH_STATUS_FAILURE = `${STORE_KEY}/FETCH_AUTH_STATUS_FAILURE`

export const FETCH_AUTH_USER_SUCCESS = `${STORE_KEY}/FETCH_AUTH_USER_SUCCESS`
export const FETCH_AUTH_USER_FAILURE = `${STORE_KEY}/FETCH_AUTH_USER_FAILURE`

export const LOGOUT = `${STORE_KEY}/LOGOUT`
